import { render, staticRenderFns } from "./examPaper.vue?vue&type=template&id=13cbd782&scoped=true"
import script from "./examPaper.vue?vue&type=script&lang=js"
export * from "./examPaper.vue?vue&type=script&lang=js"
import style0 from "./examPaper.vue?vue&type=style&index=0&id=13cbd782&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13cbd782",
  null
  
)

export default component.exports